export const enumCheckInTypology = {
    QrCodeCheckIn: 1,
    ManualCheckIn: 2,
};